(() => {
  const initializeReservationForm = (form) => {
    if (form.dataset.nipponReservationInitialized === 'true') return;

    const email = form.querySelector('[data-nippon-reservation-email]');
    const submit = form.querySelector('[data-nippon-reservation-submit]');

    if (!email || !submit) return;

    const updateButtonState = () => {
      const isReady = email.value.trim() !== '' && email.checkValidity();

      submit.disabled = !isReady;
      submit.classList.toggle('is-ready', isReady);
      submit.setAttribute('aria-disabled', String(!isReady));
    };

    email.addEventListener('input', updateButtonState);
    email.addEventListener('change', updateButtonState);
    form.dataset.nipponReservationInitialized = 'true';
    updateButtonState();
  };

  const initializeSetReservation = (section) => {
    if (section.dataset.nipponSetReservationInitialized === 'true') return;

    const dialog = section.querySelector('[data-nippon-set-dialog]');
    const triggers = section.querySelectorAll('[data-nippon-set-trigger]');

    if (!dialog || triggers.length === 0) return;

    const select = dialog.querySelector('[data-nippon-set-select]');
    const email = dialog.querySelector('[data-nippon-reservation-email]');
    const close = dialog.querySelector('[data-nippon-dialog-close]');
    let activeTrigger = null;

    const closeDialog = () => {
      dialog.close();
      activeTrigger?.focus();
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        activeTrigger = trigger;

        if (select) {
          select.value = trigger.dataset.nipponSetValue || '';
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('nippon-dialog-open');
        window.requestAnimationFrame(() => email?.focus());
      });
    });

    close?.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('nippon-dialog-open');
    });

    dialog.addEventListener('cancel', () => {
      document.documentElement.classList.remove('nippon-dialog-open');
      activeTrigger?.focus();
    });

    section.dataset.nipponSetReservationInitialized = 'true';

    if (dialog.dataset.openOnLoad === 'true' && !dialog.open) {
      dialog.showModal();
      document.documentElement.classList.add('nippon-dialog-open');
      window.requestAnimationFrame(() => email?.focus());
    }
  };

  const initialize = (root = document) => {
    root.querySelectorAll('.nippon-reservation-form').forEach(initializeReservationForm);
    root.querySelectorAll('[data-nippon-set-reservation]').forEach(initializeSetReservation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
